import { render, staticRenderFns } from "./DoTest.vue?vue&type=template&id=1d59d474&"
import script from "./DoTest.vue?vue&type=script&lang=js&"
export * from "./DoTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports